import { InjectionToken } from '@angular/core';
import { MediaBreakpoints } from '@backbase/ui-ang/media-query-lib';

export interface LayoutConfig {
  collapseBreakpoint: MediaBreakpoints;
}

export const LAYOUT_CONFIG_TOKEN = new InjectionToken<LayoutConfig>('injectable token for LayoutService');
